import React from 'react';
import PropTypes from 'prop-types';
import isViewMobile from '../../js/app/react/isViewMobile';
import ReactHighcharts from '../CommonComponents/Highcharts';

const NetWorthChartView = ({ chartData }) => {
  if (!chartData) {
    return (
      <div id="nwc_reactor">
        <div className="empty">
          <p>No net worth history data available for past 30 days.</p>
        </div>
      </div>
    );
  }

  return (
    <div id="nwc_reactor">
      <ul className="legend">
        {!isViewMobile() && (
          <li className="line">
            <i />
            Net Worth
          </li>
        )}
        <li className="blue">
          <i />
          Assets
        </li>
        <li className="purple">
          <i />
          Liabilities
        </li>
      </ul>

      <ReactHighcharts container="nwc_chart" options={chartData} />
    </div>
  );
};

NetWorthChartView.defaultProps = {
  chartData: null,
};

NetWorthChartView.propTypes = {
  chartData: PropTypes.shape({}),
};

export default NetWorthChartView;
